export default {
  methods: {
    delegateHigher (e) { this.$emit('paste', e); }
  },
}